(function () {
  const initializeEmailSignupTerms = (scope = document) => {
    scope.querySelectorAll('.email-signup__form').forEach((form) => {
      const checkbox = form.querySelector('[data-email-signup-terms]');
      const submitButton = form.querySelector('[data-email-signup-submit]');

      if (!checkbox || !submitButton || checkbox.dataset.submitControlInitialized === 'true') return;

      const updateSubmitButton = () => {
        const isAccepted = checkbox.checked;
        submitButton.disabled = !isAccepted;
        submitButton.setAttribute('aria-disabled', String(!isAccepted));
      };

      checkbox.dataset.submitControlInitialized = 'true';
      checkbox.addEventListener('change', updateSubmitButton);
      updateSubmitButton();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeEmailSignupTerms());
  } else {
    initializeEmailSignupTerms();
  }

  document.addEventListener('shopify:section:load', (event) => initializeEmailSignupTerms(event.target));
})();
